import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  Card,
  Col,
  Typography,
  Row,
  Form,
  Input,
  Space,
  message,
  Tooltip,
} from "antd";

import Powerful from "assets/Images/undraw_create_account.svg";
import sdk from "sdk/Accounts";
import { Auth } from "aws-amplify";
import { setAccountDetails, setLoginData } from "store/actions/loginAction";
import Modal from "antd/lib/modal/Modal";
import { CloseOutlined, InfoCircleOutlined, } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { CurrentUserSessionHelper } from "utility/CurrentUserSessionHelper";
import { fetchSystemConfiguration, updateCustomerAdditionalAccountData } from "apiService/RESTApi";
import { systemConfigurationFetchedFromServer } from 'store/actions/SystemConfigurationAction';
import validateField from "../../../utility/validateField";


const NewAccount = ({ expand, select, reset }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [addCompanyErrors, setAddCompanyErrors] = useState({})
  
  useEffect(() => {
      fetchSystemConfiguration().then(response => {
            dispatch(systemConfigurationFetchedFromServer(response));
        });
    }, []);

  const handleSubmit = async (e) => {
    setAddCompanyErrors({})
    const clientSideRegExValidatedFields = ["subdomain", "alias"]
    const validationErrors = {};
    validationErrors.trackKey = (key) => {
      if (validationErrors["keys"] === undefined) {
        validationErrors["keys"] = []
      }
      if (validationErrors["keys"].find(x => x.toLowerCase() === key.toLowerCase()) === undefined) {
        validationErrors["keys"].push(key)
      }
    }
    validationErrors.add = (key, data) => {
      validationErrors.trackKey(key)
      validationErrors[key] = data.join(" ")
    }
    validationErrors.hasErrors = () => {
      if (validationErrors["keys"] === undefined) {
        validationErrors["keys"] = []
      }
      return validationErrors["keys"].length > 0
    }

    clientSideRegExValidatedFields.forEach(field => {
      const errors = validateField(field, e[field]);
      if (errors.length > 0) {
          validationErrors.add(field, errors)
      }
    })

    if (validationErrors.hasErrors()) {
      setAddCompanyErrors(validationErrors)
      return;
    }

    setLoading(true);

    let result = await sdk.createAccount(e.company, e.url, [], false);
    if (result.error) {
      message.error(result.error, 5);
    } else {

      try {
        await updateCustomerAdditionalAccountData(result?.msg, { "subDomain" : e.subdomain, "alias" : e.alias });
      }
      catch(error) {
        if (error.response.status === 400) {
          Object.keys(error.response.data).forEach(key => {
            validationErrors.add(key, error.response.data[key])
          })
        }
        else {
          console.error(error)
        }
      }

      if (validationErrors.hasErrors()) {
        setAddCompanyErrors(validationErrors)
        alert(`Company ${e.company} was saved, however the Link Shortener Subdomain or the ChatStream Subdomain was not correctly saved. Please contact support`)
      }
      message.success(`Account created successfully!`);
      await fetchUser();
      return;
    }
    setLoading(false);
    reset();
  };

  const fetchUser = async () => {
    const cognitoUser = await Auth.currentAuthenticatedUser();
    const currentSession = await Auth.currentSession();
    cognitoUser.refreshSession(
      currentSession.refreshToken,
      async (err, session) => {
        const response = Auth.currentUserInfo();
        response.then((data) => {
          dispatch(setLoginData(session, data?.attributes));
        });
        let cognitoGroups = CurrentUserSessionHelper.getOnlyCustomerCognitoGroups(
          CurrentUserSessionHelper.getCognitoGroupsFromAccessToken(
            session?.accessToken
          )
        );
        if (cognitoGroups?.length > 0) {
          let res = await sdk.fetchAccount(cognitoGroups[0]);
          dispatch(setAccountDetails(res));
          history.push("/");
        }
      }
    );
  };

  return (
    <>
      <Card
        style={{ border: "none" }}
        className="selection-card selection-card-new"
      >
        <Row style={{ justifyContent: "space-around" }}>
          <Col span={6} style={{ display: "flex", justifyContent: "left" }}>
            <div style={{ width: "100%", margin: "20px 0px" }}>
              <img
                src={Powerful}
                alt="new account"
                style={{ width: "100%", maxHeight: "145px" }}
              />
            </div>
          </Col>
          <Col
            span={14}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "left",
            }}
          >
            <Typography.Title
              level={4}
              style={{ textAlign: "left", fontSize: "22px" }}
            >
              Setup A New Company
            </Typography.Title>
            <Typography.Paragraph
              style={{
                fontWeight: "normal",
                fontSize: "16px",
                textAlign: "left",
                display: "flex",
                justifyContent: "left",
                maxWidth: "600px",
              }}
            >
              Select continue to get started if no one at your company has set
              up a Blustream account.
            </Typography.Paragraph>

            <Row>
              <Col span={8}>
                <Button
                  type="primary"
                  block
                  className="standard-button primary-orange-button"
                  onClick={select}
                >
                  <b>Continue</b>
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
      <Modal
        className="new-account-model"
        visible={expand}
        closable={true}
        footer={null}
        centered
        closeIcon={
          <strong>
            <CloseOutlined
              style={{
                fontSize: 20,
                position: "absolute",
                color: "#ffffff",
                marginLeft: 30,
              }}
              onClick={reset}
            />
          </strong>
        }
      >
        <Row justify="center">
          <Col span={20}>
            <Typography.Title level={5} className="modal-title">
              Create New account
            </Typography.Title>
            <Typography.Text style={{ marginBottom: 20 }}>
              Please fill in the following information for you company so we can
              provision your trial account
            </Typography.Text>

            <Form
              labelCol={{ xs: 24 }}
              requiredMark={false}
              layout="vertical"
              name="new_account"
              className="login-form"
              onFinish={(e) => handleSubmit(e)}
              style={{ paddingTop: 15 }}
            >
              <Space direction="vertical" style={{ width: "100%" }}>
                <Form.Item
                  name="company"
                  style={{
                    marginTop: "0px",
                    marginBottom: "12px",
                  }}
                  rules={[
                    {
                      required: true,
                      message: "Please enter the name of your company",
                    },
                    {
                      pattern: /(^[a-zA-Z0-9]{1})([a-zA-Z0-9& .]+)/,
                      message: "Please enter valid company name",
                    },
                  ]}
                >
                  <Input
                    className="standard-input"
                    size="large"
                    id="company"
                    key="company"
                    name="company"
                    placeholder="Company Name"
                    disabled={loading}
                    tabIndex={1}
                  />
                </Form.Item>
                <Form.Item
                  name="url"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the URL of your company",
                    },
                    {
                      pattern:
                        /(www\.)?[-a-zA-Z0-9_]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/,
                      message: "Please enter valid URL",
                    },
                  ]}
                >
                  <Input
                    className="standard-input"
                    size="large"
                    id="url"
                    key="url"
                    name="url"
                    placeholder="Company URL"
                    disabled={loading}
                    tabIndex={1}
                  />
                </Form.Item>

              <Form.Item
                name="alias"
                validateStatus={addCompanyErrors.alias ? 'error' : ''}
                help={addCompanyErrors.alias ? addCompanyErrors.alias : null}
                rules={[
                  {
                    required: true,
                    message: "Please enter Link Shortener Subdomain",
                  }
                ]}
              >
                
                <Input
                  className="standard-input"
                  size="left"
                  id="alias"
                  key="alias"
                  name="alias"
                  placeholder="Link Shortener Subdomain"
                  disabled={loading}
                  tabIndex={2}
                  style={{ width: "95%", float: "left"}}
                />
                <Tooltip
                  placement="right"
                  title="The link shortening subdomain will be appended to all trackable links we send on your behalf. It helps to promote trust with your customers when they see a link coming from you that isn't from your website. e.g. mycompany.bstrm.io/go?l=123" >
                  <InfoCircleOutlined style={{ paddingLeft: "3px" }} />
                </Tooltip>
              </Form.Item>

              <Form.Item
                name="subdomain"
                validateStatus={addCompanyErrors.subdomain ? 'error' : ''}
                help={addCompanyErrors.subdomain ? addCompanyErrors.subdomain : null}
                rules={[
                  {
                    required: true,
                    message: "Please enter ChatStream Subdomain",
                  }
                ]}
              >
                <Input
                  className="standard-input"
                  size="middle"
                  id="subdomain"
                  key="subdomain"
                  name="subdomain"
                  placeholder="ChatStream Subdomain"
                  disabled={loading}
                  tabIndex={3}
                  style={{ width: "95%", float: "left"}}
                />
                <Tooltip
                  placement="right"
                  title="This subdomain will be used to host your ChatStream site. Share it with your users so they can access easily. e.g. myconcierge.myblustream.io" >
                  <InfoCircleOutlined style={{ paddingLeft: "3px" }} />
                </Tooltip>
              </Form.Item>


                <Form.Item>
                  <Button
                    type="primary"
                    size="large"
                    block
                    htmlType="submit"
                    loading={loading}
                    tabIndex={5}
                    className="standard-button primary-orange-button"
                  >
                    Get Started
                  </Button>
                </Form.Item>
              </Space>
            </Form>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default NewAccount;
